<template>
    <modal :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0" :class="{'loading-opacity': preloader}" ref="form" :data-url='selectedUrl ? `master/center/${inputs.id}` : `master/center`'>

                <div class="form-group row align-items-center">
                    <label for="inputs_name" class="col-sm-3 mb-0">
                        {{ $t('name') }}
                    </label>
                    <app-input id="inputs_name"
                               class="col-sm-9"
                               type="text"
                               v-model="inputs.name"
                               :placeholder="$t('name')"
                               :required="true"/>

                </div>

                <div class="form-group row align-items-center">
                    <label for="inputs_is_active" class="col-sm-3 mb-0">
                        &nbsp;
                    </label>
                    <div class="col-sm-8">
                        <app-input id="inputs_is_active" :list-value-field="$t('is_active')" type="single-checkbox" v-model="inputs.is_active" />
                    </div>
                </div>
                
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from "../../../../../../../../core/mixins/form/FormMixin.js";
    import {ModalMixin} from "../../../../../../../Mixins/ModalMixin";

    export default {
        name: "StudyDetailsForm",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            formId: String,
            value: {
                type: Object,
                default: () => {
                    return {
                        id: undefined,
                        name: '',
                        is_active: ''
                    }
                },
            }
        },
        data() {
            return {
                preloader: false,
                inputs: {
                    name: '',
                },
                modalId: this.formId,
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                if (response.data.phone) this.phone = response.data.phone;
                this.inputs = response.data;
                this.preloader = false;
            }
        },
    }
</script>
